<script>
export default {
  name: "FilesCountComponent",
  props: {
    prompt: {
      type: String,
      required: true
    },
    countFiles: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div class="files-count">
    <b>Добавлено:</b> {{ countFiles }} файл(а)
    <span v-if="prompt" class="prompt-modal">
      <span>(Что загружать?)<span v-html="prompt"></span></span>
    </span>
  </div>
</template>

<style scoped>

.files-count {
  color: #3294ca;
  font-size: 18px;
  margin-bottom: 10px;
}

.prompt-modal {
  margin-bottom: 10px;
}

.prompt-modal>span {
  position: relative;
  display: inline-block;
  color: #3294ca;
  font-size: 18px;
}

.prompt-modal>span>span {
  border: 1px solid #cdcdcd;
  background-color: #ffffff;
  padding: 10px;
  border-radius: 5px;
  color: #606060;
  box-shadow: 0 0 5px rgb(0 0 0 / 10%);
  position: absolute;
  width: 900px;
  top: 17px;
  left: 0;
  display: none;
  z-index: 3;
}

.prompt-modal:hover>span>span {
  display: block;
}

.prompt-modal>span>span p {
  line-height: 19px;
}

@media (max-width: 768px) {

  .files-count {
    display: none;
  }

}

</style>
